import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'

import { CONFIG } from '../../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/registration/grupo-produto`

const GrupoProdutoHttp = {
  getGrupos: async empresa_id => {
    try {
      const url = BASE_URL + `/${empresa_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  salvarGrupo: async (grupo, empresa_id) => {
    try {
      const url = BASE_URL + `/${empresa_id}`
      const response = await authHttp().post(url, grupo)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default GrupoProdutoHttp
